export default "__VITE_ASSET__a5954f1d__"